function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  font-size: inherit;\n\n  &:checked {\n    & + ", " {\n      background: ", ";\n\n      & + ", " {\n        background-color: ", ";\n        left: calc(2.25rem - 1.375rem);\n      }\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  content: '';\n  height: 1.375rem;\n  width: 1.375rem;\n  border-radius: 50%;\n  top: 0;\n  left: 0;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);\n  background-color: ", ";\n  transition: all 0.3s;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: calc((1.375rem - 0.74rem) / 2) 0;\n  height: 0.75rem;\n  width: 2.25rem;\n  background: ", ";\n  border-radius: 16px;\n  cursor: pointer;\n  transition: background 0.3s;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  text-align: left;\n  cursor: pointer;\n  user-select: none;\n  height: 1.375rem;\n  width: 2.25rem;\n  line-height: 1rem;\n  font-size: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../theme";
export var SwitchLabel = styled.label(_templateObject(), function (props) {
  return props.theme.variables.fonts.size.base;
});
export var Slider = styled.span(_templateObject2(), function (props) {
  return props.theme.variables.colors.platinum;
});
export var Thumb = styled.span(_templateObject3(), function (props) {
  return props.theme.variables.colors.white;
});
export var SwitchInput = styled.input(_templateObject4(), Slider, function (props) {
  return props.theme.variables.colors.lightGreen;
}, Thumb, function (props) {
  return props.theme.variables.colors.green;
});